import React, { createContext, useState, useEffect, useCallback } from 'react';

export const ThemeContext = createContext();

export default function ThemeProvider({ children }) {
    // Read initial theme from localStorage or default to 'light'
    const [theme, setThemeState] = useState(() => {
        try {
            return localStorage.getItem('solarapp-theme') || 'light';
        } catch {
            return 'light';
        }
    });

    // Apply data-theme attribute to <html> so CSS :root and body selectors work
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        try {
            localStorage.setItem('solarapp-theme', theme);
        } catch { /* ignore storage errors */ }
    }, [theme]);

    const toggleTheme = useCallback(() => {
        setThemeState(prev => (prev === 'light' ? 'dark' : 'light'));
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}
